import { BActionIcon } from '@components/BActionIcon/BActionIcon';

import {
  BlueCancel,
  Cancel,
} from '@components/Filters/Filter/components/FilterContent/FilterContent.styles';
import { Text } from '@components/index';
import { UseFilteredSearchReturn } from '@hooks/useFilteredSearch';
import { Accordion } from '@mantine/core';
import { GetDocumentsByStudioFilter } from '@services/queries/documents/getDocumentsByStudio/getDocumentsByStudio.types';
import { useState } from 'react';
import { PartialSetter } from '@pages/Products/Heading.types';
import {
  filterTabValues,
  getDefaultFilterTabs,
} from '../../logic/getDefaultFilterTabs';
import { countDocumentsFilter } from '../../logic/countDocumentsFilter';
import { FilterAccordion } from '../FilterAccordion/FilterAccordion';
import { ButtonGroup, HeaderGroup, StyledDiv } from './FilterContent.styles';
import { SourceFilter } from '../SourceFilter/SourceFilter';
import { makePartialSetter } from '../../logic/makePartialSetter';

interface IFilterPart {
  label: string;
  body: React.ReactNode;
  value: string;
}
interface FilterContentProps
  extends UseFilteredSearchReturn<GetDocumentsByStudioFilter> {
  close: VoidFunction;
}
export function FilterContent(props: FilterContentProps) {
  const { pageFilter, filterFns, close } = props;
  const [filter, _setFilter] = useState<GetDocumentsByStudioFilter>(
    pageFilter.filter,
  );

  const [setFilter] = useState<PartialSetter<GetDocumentsByStudioFilter>>(() =>
    makePartialSetter(_setFilter),
  );
  const [filterCount, parts] = countDocumentsFilter(pageFilter.filter);
  const [internalCount] = countDocumentsFilter(filter);
  const defaultValues = getDefaultFilterTabs(parts);
  const filterParts: IFilterPart[] = [
    {
      label: 'Source',
      value: filterTabValues.source,
      body: <SourceFilter filter={filter} broadcast={setFilter} />,
    },
  ];

  const actualCount0 = filterCount === 0;
  const internalCount0 = internalCount === 0;
  return (
    <StyledDiv>
      <HeaderGroup>
        <Text text="h500">Filter</Text>
        <BActionIcon onClick={close} />
      </HeaderGroup>
      <FilterAccordion
        multiple
        className="bscroll"
        defaultValue={defaultValues}
      >
        {filterParts.map(filterPart => {
          return (
            <Accordion.Item value={filterPart.value} key={filterPart.value}>
              <Accordion.Control>{filterPart.label}</Accordion.Control>
              <Accordion.Panel>{filterPart.body}</Accordion.Panel>
            </Accordion.Item>
          );
        })}
      </FilterAccordion>
      <ButtonGroup>
        <Cancel
          onClick={() => {
            filterFns.reset('filter');
            _setFilter({});
          }}
          disabled={actualCount0}
        >
          Clear
        </Cancel>
        <BlueCancel
          disabled={internalCount0 && actualCount0}
          onClick={() => filterFns.filterBy(filter)}
        >
          Confirm
        </BlueCancel>
      </ButtonGroup>
    </StyledDiv>
  );
}
